"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UploadMeterReadings = class UploadMeterReadings extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_createConsumptions = new core_1.ComponentValueCache(this, "createConsumptions", "UploadMeterReadings.createConsumptions");
    }
    onSumbitCompleted(...args) {
        const [event] = args;
        const data = event.data.response.data;
        console.log(data, this);
        if (data == null) {
            this.resultText = this.messages.noRecordsHaveBeenImported;
            return;
        }
        const consumptions = data.consumptions ? data.consumptions.length : 0, readings = data.readings ? data.readings.length : 0;
        this.resultText = this.$fn.sprintf(this.messages.recordsHaveBeenImported, {
            consumptions, readings
        });
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    createConsumptions;
    file;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    resultText;
    templateFileURL;
    async $$load_templateFileURL() {
        return this.$fn.urlFor('get_meter_readings_import_template', { format: 'xlsx' });
    }
    messages;
    ux;
    b_7315092382398562_modalBindings;
    b_3086171180629160_validation;
    dataMembers = ['createConsumptions', 'file', 'formId', 'formName', 'resultText', 'templateFileURL', 'messages', 'ux', 'b_7315092382398562_modalBindings', 'b_3086171180629160_validation'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                createConsumptions: false,
                file: null,
                formId: null,
                formName: "meterConsumptionImport",
                resultText: null,
                templateFileURL: null,
                messages: {
                    noRecordsHaveBeenImported: this.$fn.pgettext("UploadMeterReadings", "No records have been imported."),
                    recordsHaveBeenImported: this.$fn.pgettext("UploadMeterReadings", "%(readings)s readings and %(consumptions)s consumptions have been imported."),
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_3086171180629160_validation: ["ext:xlsx",
                    "required",
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("UploadMeterReadings|Title", "Upload Meter Readings"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4598_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_648747096704084_script_4604_getActionArgs_value($event) {
        this.onSumbitCompleted($event);
    }
    async act_648747096704084_script_4604_getActionArgs($event) {
        return {
            value: () => this.act_648747096704084_script_4604_getActionArgs_value($event),
        };
    }
    async act_648747096704084_request_4602_getActionArgs($event) {
        return {
            operation: "create_meter_readings_from_file",
            data: {
                file: this.file,
                create_consumptions: this.createConsumptions
            },
            contentType: "multipart/form-data",
        };
    }
    async evh_648747096704084_submit(event, scope) {
        return await this.actions.evh_648747096704084_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_4606_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4598 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4598_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4597 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4598,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4597],
        });
        const act_2248226175642056_closeComponent_4600 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_4599 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_4600,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4599],
        });
        const act_648747096704084_script_4604 = new core_1.actions.ScriptAction({
            actionArgs: this.act_648747096704084_script_4604_getActionArgs,
            events: [],
        });
        const evh_648747096704084_success_4603 = new core_1.actions.EventHandlerImpl({
            action: act_648747096704084_script_4604,
            event: "success",
            displayName: "script",
        });
        const act_648747096704084_request_4602 = new core_1.actions.RequestAction({
            actionArgs: this.act_648747096704084_request_4602_getActionArgs,
            displayName: "submit",
            events: [evh_648747096704084_success_4603],
        });
        const evh_648747096704084_submit_4601 = new core_1.actions.EventHandlerImpl({
            action: act_648747096704084_request_4602,
            event: "submit",
            displayName: "submit",
        });
        const evh_648747096704084_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_648747096704084_submit_4601],
        });
        const act_1419464017721962_closeModal_4606 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_4606_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_4605 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_4606,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_4605],
        });
        return {
            act_7315092382398562_closeModal_4598,
            evh_7315092382398562_close_4597,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_4600,
            evh_2248226175642056_close_4599,
            evh_2248226175642056_close,
            act_648747096704084_script_4604,
            evh_648747096704084_success_4603,
            act_648747096704084_request_4602,
            evh_648747096704084_submit_4601,
            evh_648747096704084_submit,
            act_1419464017721962_closeModal_4606,
            evh_1419464017721962_clickPreventStop_4605,
            evh_1419464017721962_clickPreventStop,
            submit: act_648747096704084_request_4602,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], UploadMeterReadings.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UploadMeterReadings.prototype, "onSize", null);
UploadMeterReadings = __decorate([
    (0, vue_property_decorator_1.Component)()
], UploadMeterReadings);
exports.default = UploadMeterReadings;
vue_property_decorator_1.Vue.component("UploadMeterReadings", UploadMeterReadings);
